export default "__VITE_ASSET__DlBC71yP__"